import { CreateBookingSlot, UpdateBookingSlot } from '../../types/bookingSlot';
import {
  formatToLocalDate,
  formatToLocalTime,
} from '../../utils/dateFormatter';
import { Booking } from '../../types/booking';

export interface SerializeOptions {
  includeShopId?: boolean;
}

export const serializeCreateSlotData = (
  createBookingSlot: CreateBookingSlot,
  { includeShopId = false }: SerializeOptions = {}
) => {
  return {
    ...createBookingSlot,
    ...(createBookingSlot.barber_id != null && {
      barber_id: createBookingSlot.barber_id.toString(),
    }),
    ...(createBookingSlot.service_id != null && {
      service_id: createBookingSlot.service_id.toString(),
    }),
    ...(includeShopId &&
      createBookingSlot.shop_id != null && {
        shop_id: createBookingSlot.shop_id.toString(),
      }),
    ...(createBookingSlot.start_time && {
      start_time: formatToLocalTime(createBookingSlot.start_time),
    }),
    ...(createBookingSlot.slot_date && {
      slot_date: formatToLocalDate(createBookingSlot.slot_date),
    }),
  };
};

export const serializeUpdateSlotData = (
  updateBookingSlot: UpdateBookingSlot,
  { includeShopId = false }: SerializeOptions = {}
) => {
  return {
    ...(updateBookingSlot.status && { status: updateBookingSlot.status }),
    ...(updateBookingSlot.barber_id != null && {
      barber_id: updateBookingSlot.barber_id.toString(),
    }),
    ...(updateBookingSlot.service_id != null && {
      service_id: updateBookingSlot.service_id.toString(),
    }),
    ...(includeShopId &&
      updateBookingSlot.shop_id != null && {
        shop_id: updateBookingSlot.shop_id.toString(),
      }),
    ...(updateBookingSlot.start_time && {
      start_time: formatToLocalTime(updateBookingSlot.start_time),
    }),
    ...(updateBookingSlot.slot_date && {
      slot_date: formatToLocalDate(updateBookingSlot.slot_date),
    }),
  };
};

export const serializeReservationData = (reservation: Booking): string => {
  const serializedReservation: Record<string, any> = {
    customer_email: reservation.customer_email,
    customer_phone: reservation.customer_phone,
    customer_name: reservation.customer_name,
    barber_name: reservation.barber_name,
    barber_email_address: reservation.barber_email_address,
    service_name: reservation.service_name,
    price: reservation.price,
    status: reservation.status,
    type: reservation.type,
    slot_id: reservation.slot_id,
  };

  if (reservation.id) {
    serializedReservation.id = reservation.id;
  }

  if (reservation.shop_id !== undefined) {
    serializedReservation.shop_id = reservation.shop_id.toString();
  }

  if (reservation.barber_id !== undefined) {
    serializedReservation.barber_id = reservation.barber_id.toString();
  }

  return JSON.stringify(serializedReservation);
};
